/**
 * Cancel flow types and default configuration.
 *
 * The default export of this file is compiled to dist/default-config.json
 * during the build process (see createConfigJsonPlugin in build.js). The
 * JSON output is used to provision and update merchant cancel flow configs.
 *
 * If making major changes to the default config, make sure it's copied over to old-configs/ so we can test our validation logic against the historical version.
 * Not every config iteration needs to be there, just ones with significant schema changes.
 */
import defaultNodes from './default-nodes';
import type { CancelFlowConfig } from '../types';

// this config is just for testing purposes and generating an export at build time
// the merchant's actual config is injected via SOS
const config: CancelFlowConfig = {
  locales: {
    'en-US': {
      close: 'Close',
      goBack: 'Go back',
      continue: 'Cancel anyways',
      day: 'day',
      days: 'days',
      week: 'week',
      weeks: 'weeks',
      month: 'month',
      months: 'months'
    },
    'en-CA': {
      close: 'Close',
      goBack: 'Go back',
      continue: 'Cancel anyways',
      day: 'day',
      days: 'days',
      week: 'week',
      weeks: 'weeks',
      month: 'month',
      months: 'months'
    },
    'fr-CA': {
      close: 'Fermer',
      goBack: 'Retour',
      continue: 'Annuler quand même',
      day: 'jour',
      days: 'jours',
      week: 'semaine',
      weeks: 'semaines',
      month: 'mois',
      months: 'mois'
    },
    'es-ES': {
      close: 'Cerrar',
      goBack: 'Volver',
      continue: 'Cancelar de todos modos',
      day: 'día',
      days: 'días',
      week: 'semana',
      weeks: 'semanas',
      month: 'mes',
      months: 'meses'
    }
  },
  defaults: {
    ineligible: 'benefit-reminder'
  },
  nodes: [
    { type: 'cancel-flow:start', name: 'start', parameters: defaultNodes['cancel-flow:start'] },
    { type: 'cancel-flow:survey', name: 'survey', parameters: defaultNodes['cancel-flow:survey'] },
    { type: 'cancel-flow:skip', name: 'skip', parameters: defaultNodes['cancel-flow:skip'] },
    { type: 'cancel-flow:sku-swap', name: 'sku-swap', parameters: defaultNodes['cancel-flow:sku-swap'] },
    { type: 'cancel-flow:pause', name: 'pause', parameters: defaultNodes['cancel-flow:pause'] },
    {
      type: 'cancel-flow:retention-discount',
      name: 'retention-discount',
      parameters: defaultNodes['cancel-flow:retention-discount']
    },
    {
      type: 'cancel-flow:benefit-reminder',
      name: 'benefit-reminder',
      parameters: defaultNodes['cancel-flow:benefit-reminder']
    },
    {
      type: 'cancel-flow:cancel-subscription',
      name: 'cancel-subscription',
      parameters: defaultNodes['cancel-flow:cancel-subscription']
    }
  ]
};

export default config;
